import { HEADER_HEIGHT, TOP_BAR_HEIGHT } from "@v2/components/header/constants";

// The heights the sticky toolbar and everything that scrolls under it agree on.
// They live outside the toolbar component because the pages that place anchors are
// server rendered and cannot read anything out of a client module.

const PLP_HEADER_HEIGHT = {
    xs: 72,
    sm2: 90,
    md: 90,
} as const;

// Below md the toolbar wraps its summary onto a second row and needs the extra height;
// from md up it is one row again, so the original height already fits.
const PLP_HEADER_HEIGHT_STACKED = {
    // 36 + 34 for the rows, 8 between them, 11 above and below.
    xs: 100,
    sm2: 90,
    md: 90,
} as const;

export const plpHeaderHeight = (stacked: boolean) => (stacked ? PLP_HEADER_HEIGHT_STACKED : PLP_HEADER_HEIGHT);

// Where anything pinned under the open site header comes to rest. The toolbar
// sticks here, and whatever the page scrolls to stops here too, so the two read
// the same offset instead of drifting apart.
export const PLP_STICKY_TOP = {
    xs: HEADER_HEIGHT.mobile + TOP_BAR_HEIGHT,
    md: HEADER_HEIGHT.tablet + TOP_BAR_HEIGHT,
    md2: HEADER_HEIGHT.desktop + TOP_BAR_HEIGHT,
} as const;

/**
 * Where the product list itself comes to rest when something scrolls to it. The
 * toolbar is sticky above the list, so stopping at the list's own top would park
 * its first row behind the toolbar. This clears the top bar and the toolbar both.
 */
export const plpListScrollMargin = (stacked: boolean) => {
    const height = plpHeaderHeight(stacked);

    return {
        xs: TOP_BAR_HEIGHT + height.xs,
        sm2: TOP_BAR_HEIGHT + height.sm2,
        md: TOP_BAR_HEIGHT + height.md,
    };
};
